import { ADMIN_SERVICE_URL } from 'config'
import { authorizedPipe, RequestBuilder } from 'services/net'

const ENDPOINT_SEARCH_APPS = `${ADMIN_SERVICE_URL}/app/search`
const ENDPOINT_UPDATE_APP = `${ADMIN_SERVICE_URL}/app/update`

export function searchApps(id: string) {
  const builder = new RequestBuilder(ENDPOINT_SEARCH_APPS).asPost().expectJSON()
  return authorizedPipe<any>(
    builder
      .body({ needle: id })
      .build()
  )
}

export function updateApp(
  appId: string,
  profilesLimit?: number,
  postsPerDay?: number,
  locations?: number,
  cid?: string,
  isBeta?: '0' | '1',
  igDirect?: boolean,
  stripeId?: string,
  nextRenewal?: string,
  tier?: number,
  currency?: 'usd' | 'inr'
) {
  const data: any = { id: appId, is_beta: isBeta }
  if (profilesLimit) {
    data.profiles_limit = profilesLimit
  }
  if (postsPerDay) {
    data.posts_per_day = postsPerDay
  }
  if (typeof locations === 'number') {
    data.allowed_locations = locations
  }
  if (typeof cid === 'string') {
    data.chargify_subscription_id = cid
  }
  if (typeof igDirect === 'boolean') {
    data.config = { ig_with_fb: !igDirect }
  }
  if (typeof stripeId === 'string') {
    data.stripe_subscription_id = stripeId
  }
  if (typeof nextRenewal === 'string') {
    data.next_renewal = nextRenewal
  }
  if (typeof tier === 'number') {
    data.tier = tier
  }
  if (typeof currency === 'string') {
    data.currency = currency
  }
  const builder = new RequestBuilder(ENDPOINT_UPDATE_APP).asPost().expectJSON()
  return authorizedPipe<any>(
    builder
      .body(data)
      .build()
  )
}

export function getFeatureFlags() {
  const builder = new RequestBuilder(`${ADMIN_SERVICE_URL}/app/feature_flags`).asGet().expectJSON()
  return authorizedPipe<any>(
    builder.build()
  )
}

export const adminGetSubscription = function (id: string) {
  const builder = new RequestBuilder(`${ADMIN_SERVICE_URL}/app/get_subscription`).asPost().expectJSON()
  builder.body({ stripe_subscription_id: id })
  return authorizedPipe<any>(builder.build())
}
